import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { H6 } from '@blueprintjs/core';
import { TablePagination, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import Chart from 'react-apexcharts';
import '../results.css';
import {estimatedClass} from '../common'
import { rounded }  from '../../../utils.js'
import { CsvBuilder } from "filefy";
import Cookies from 'js-cookie';
import { FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME } from '../../../auth/constants.js';
import {MAX_CHART_SIZE} from '../../../constants.js';

class DetailByCorpus extends React.PureComponent {


  render() {
    const { corpusStats, t, incompleteExtraction } = this.props;
    const userFrontNotLoggedIn= !(Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME));

    let type;
    let typeLabel;
    let level;
    switch (this.props.type) {
      case 'freqByCorpus':
        type = 'freq';
        typeLabel = t('frequency');
        level = 'byCorpus'
        break;
      case 'freqByDoc':
        type = 'freq';
        typeLabel = t('frequency');
        level = 'byDoc'
        break;
      case 'specByCorpus':
        type = 'specificity';
        typeLabel = t('specificity');
        level = 'byCorpus'
        break;
      case 'specByDoc':
        type = 'specificity';
        typeLabel = t('specificity');
        level = 'byDoc'
        break;
      case 'dispByCorpus':
        type = 'disp';
        level = 'byCorpus'
        typeLabel = t('dispersion');
        break;
      default:
        break;
    }


    let dataChart = [];
    let data = [];
    let columns= [
      { title: t('name'), field: 'name' },
      { title: t('frequency'), 
        field: 'frequency', 
        customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.frequency,
        render:  rowData => <span className={estimatedClass(rowData.frequency,incompleteExtraction)}>{rounded(rowData.frequency)}</span>
      },
      { title: t('relativeFrequency'), 
        field: 'relativeFrequency', 
        customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.relativeFrequency,
        render:  rowData => <span className={estimatedClass(rowData.relativeFrequency,incompleteExtraction)}>{rowData.relativeFrequency}</span>
      }
    ];
    let fields={'name':true};

    for (const corpusOrDoc in corpusStats) {
      let name=corpusOrDoc;
      
      if (corpusStats[corpusOrDoc]['title']) {
        name=corpusStats[corpusOrDoc]['title'];
      }
      const row = {
        name: name,
      };
      row['frequency']=corpusStats[corpusOrDoc]['freq'];
      row['relativeFrequency']=corpusStats[corpusOrDoc]['size']? rounded(corpusStats[corpusOrDoc]['freq']/corpusStats[corpusOrDoc]['size']*1000000,2):0;
      if (corpusStats[corpusOrDoc]['disp']) {
        row['dispersion']=corpusStats[corpusOrDoc]['disp'];
         // adding (once) a column for dispersion in the table
        if (! fields['dispersion']) {
          columns.push({ 
                        title:t('dispersion')+" ("+this.props.dispCriterion+")", 
                        customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.dispersion,
                        field: 'dispersion', 
                        render:  rowData => <span className={estimatedClass(rowData.dispersion,incompleteExtraction)}>{rounded(rowData.dispersion)}</span>
          });
          fields['dispersion']=true;
        }

        if (corpusStats[corpusOrDoc]['disps']) {
          for (var key of Object.keys(corpusStats[corpusOrDoc]['disps']).sort()) {
            row[key]=corpusStats[corpusOrDoc]['disps'][key];
             // adding (once) a column for key dispersion in the table
            if (! fields[key]) {
              columns.push({ title: key, field: key });
              fields[key]=true;
            }

          }
        }
      }
      if (corpusStats[corpusOrDoc]['specificity']) {
        row['specificity']=corpusStats[corpusOrDoc]['specificity'];
        // adding (once) a column for specificity in the table
        if (! fields['specificity']) {
          columns.push({ title:t('specificity'), 
                         field: 'specificity',
                         customFilterAndSearch: (term, rowData) => ~~term <= ~~rowData.specificity,
                         render:  rowData => <span className={estimatedClass(rowData.specificity,incompleteExtraction)}>{rounded(rowData.specificity)}</span>
          });
          fields['specificity']=true;
        }
      }
      data.push(row);

      const rowChart = {
        title: name,
        value: corpusStats[corpusOrDoc][type]
      };
      dataChart.push(rowChart);


    }

    // sort data by decreasing order
    dataChart.sort((a, b) => a.title < b.title);
    dataChart.reverse();
    dataChart=dataChart.slice(0,MAX_CHART_SIZE);

    const typeLabelLower = typeLabel.toLowerCase();

    const titlesTable = (
      <MaterialTable
        columns={columns}
        data={data}
        title={`${typeLabel} ${t(level)}`}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:`${typeLabelLower}_by_corpus`,
          exportAllData: true,
        }}
        components={{
          exportCsv: (columns, data) => {
            const fileName = typeLabelLower+"_stats";
            const builder = new CsvBuilder(
                fileName + ".csv"
            );
            builder
                .setColumns( Object.keys(fields).sort() )
                .setDelimeter(this.props.csvDelimiter).addRows(
                  data.map((rowData) => Object.keys(fields).sort().map(key=>rowData.key))
                )
                .exportFile();
          },
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[10, 25, 50, 100, data.length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
            />
          ),
        }}
      />
    );

    // prep data for the chart
    const series = [{
        name:typeLabel,
        data:dataChart.map(e=>e.value)
    }];
    const options = {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            // colors: {
            //   ranges: [{
            //     from: -100,
            //     to: -46,
            //     color: '#F15B46'
            //   }, {
            //     from: -45,
            //     to: 0,
            //     color: '#FEB019'
            //   }]
            // },
            columnWidth: '80%',
          }
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: typeLabel,
          },
          labels: {
            formatter: function (y) {
              return rounded(y,2);
            }
          }
        },
        xaxis: {
          type: 'text',
          categories: dataChart.map(el=>(el.title)),
          labels: {
            rotate: -90
          }
        }
    };

    return(
      <>
        { 
          userFrontNotLoggedIn && 
          <p>{t('noTitleIfNotLogged')}</p>
        }  
 
        <div className="margin-bottom-1-rem">
          <H6><u>{t('graphicalRepr')}</u></H6>
            <div id="chart">
                <Chart options={options} series={series} type="bar" height={350} />
            </div>
        </div>

        <H6><u>{t('completeResList')}</u></H6>
        {titlesTable}
      </>
    );
  }
}

DetailByCorpus.propTypes = {
  corpusStats: PropTypes.object,
  type: PropTypes.string,
  incompleteExtraction:PropTypes.bool,
  performSearch: PropTypes.func,
  dispCriterion: PropTypes.string,
  csvDelimiter: PropTypes.string,
};

export default withTranslation()(DetailByCorpus);
